import { render, staticRenderFns } from "./selectgoods.vue?vue&type=template&id=6c780e12&scoped=true"
import script from "./selectgoods.vue?vue&type=script&lang=js"
export * from "./selectgoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c780e12",
  null
  
)

export default component.exports